module.exports = __webpack_public_path__ + "static/media/YM90_3.3ced2752.jpg";